import COLORS from '../../../utils/constants/colors'

const mobileScheduleStyles = {
  wrapper: {
    paddingBottom: 80,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '12px 0 8px',
  },
  monthTitle: {
    flex: 1,
    fontSize: 22,
    fontWeight: 500,
  },
  empty: {
    padding: '32px 0',
    textAlign: 'center',
    color: COLORS.darkGrey,
  },
  dayRow: {
    display: 'flex',
    gap: 12,
    padding: '10px 0',
    scrollMarginTop: 8,
  },
  dayLabel: {
    width: 44,
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  weekday: {
    fontSize: 12,
    fontWeight: 500,
    color: COLORS.darkGrey,
  },
  weekdayToday: {
    fontSize: 12,
    fontWeight: 500,
    color: COLORS.orange,
  },
  dayNumber: {
    width: 36,
    height: 36,
    lineHeight: '36px',
    textAlign: 'center',
    fontSize: 20,
  },
  dayNumberToday: {
    width: 36,
    height: 36,
    lineHeight: '36px',
    textAlign: 'center',
    fontSize: 20,
    borderRadius: '50%',
    backgroundColor: COLORS.orange,
    color: COLORS.white,
  },
  dayEvents: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    paddingTop: 16,
  },
  nothingToday: {
    fontSize: 14,
    color: COLORS.darkGrey,
    padding: '6px 0',
  },
  eventCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    padding: '8px 12px',
    border: 'none',
    borderRadius: 8,
    font: 'inherit',
    textAlign: 'left',
    cursor: 'pointer',
  },
  eventTitle: {
    fontSize: 15,
    fontWeight: 500,
    lineHeight: 1.3,
    overflowWrap: 'anywhere',
  },
  eventTime: {
    fontSize: 13,
    marginTop: 2,
    opacity: 0.85,
  },
}

export default mobileScheduleStyles
